export default __webpack_public_path__ + "f6fd8246b9262ffec8af4b9802417e6e.png";